import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeSharedSideMenu(): Provider {
  return provideTranslocoScope({
    scope: 'shared-side-menu',
    alias: 'sharedSm',
    loader: i18nLoader,
  });
}
